import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Title from '@components/title'
import { Button } from '@components/ui/button'

const NotFoundPage = () => {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setLoaded(true)
    }, 1000)
  }, [])

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <Title title="Not Found" />

      {loaded && (
        <div className="space-y-4 text-center">
          <h1 className="text-6xl font-bold text-foreground">404</h1>
          <p className="text-muted-foreground text-sm uppercase">
            Page not found
          </p>
          <Link to="/">
            <Button className="mt-8" variant="outline">
              Go back home
            </Button>
          </Link>
        </div>
      )}
    </div>
  )
}

export default NotFoundPage
